export default __webpack_public_path__ + "static/media/vinous_logo.c5792f21.png";